












































































































































































































































































































































































































































import Card from "@/components/UI/Card.vue";
import {Component, Prop, Mixins} from "vue-property-decorator";
import Toast from "@/mixins/toast";
import moment from "moment";

interface FilterItem {
	id: number;
	text: string;
	value: number;
	isSelected: boolean;
}

interface CombinedFilters {
	groups: FilterItem[];
	categories: FilterItem[];
	subcategories: FilterItem[];
	storeFormat: FilterItem[];
	storeRegion: FilterItem[];
	storeCluster: FilterItem[];
}

interface TheMarket {
	id: number;
	tradingName: string;
	isDefault: boolean;
	editable: boolean;
}

@Component({
	components: {
		Card,
	},
})
export default class CompetitorsDirectory extends Mixins(Toast) {
	@Prop({required: true}) theFilters!: CombinedFilters;
	@Prop({required: true, default: {id: 0, tradingName: "", isDefault: false, editable: true}}) theMarket!: TheMarket;

	competitorsFilters = {
		theErrorAmount: 0 as number,
		theUpdateModal: false as boolean,
		theFile: null as File | null,
		theFileModal: false as boolean,
		theChecksAction: "delete" as string,
		theTradingId: this.theMarket ? this.theMarket.id : 157,
		theCompetitorName: "",
		theAddress: "",
		theSortField: "competitorName" as string,
		theSortDirectorion: "ASC" as string,
		isClusterEmpty: false as boolean,
		get theButtonsStatus(): boolean {
			return !this.theFile;
		},
	};
	competitorsBody = {
		theDeleteModal: false as boolean,
		theDeleteIds: [] as any,
		isTableLoading: false as boolean,
		isTableFullUpdating: false as boolean,
	};

	// таблица
	competitorsDirectoryTableColumns: any[] = [
		{
			key: "storeChecked",
			dataIndex: "storeChecked",
			title: "",
			scopedSlots: {
				customRender: "storeChecked",
			},
			fixed: "left",
			width: 40,
		},
		{
			key: "storeFormat",
			dataIndex: "storeFormat",
			title: this.$t('priceMonitoring.competitorsDirectory.formatChannel') as string,
			scopedSlots: {
				filterDropdown: "storeFormat",
				filterIcon: "storeFormatFilterIcon",
			},
			sorter: true,
			ellipsis: true,
			fixed: "left",
			width: 200,
		},
		{
			key: "storeRegion",
			dataIndex: "storeRegion",
			title: this.$t('shared.filters.storeRegion') as string,
			scopedSlots: {
				filterDropdown: "storeRegion",
				filterIcon: "storeRegionFilterIcon",
			},
			sorter: true,
			ellipsis: true,
			fixed: "left",
			width: 200,
		},
		{
			key: "storeCluster",
			dataIndex: "storeCluster",
			title: this.$t('shared.filters.storeCluster') as string,
			scopedSlots: {
				filterDropdown: "storeCluster",
				filterIcon: "storeClusterFilterIcon",
			},
			sorter: true,
			ellipsis: true,
			width: 200,
		},
		{
			key: "competitorCode",
			dataIndex: "competitorCode",
			title: this.$t('shared.table.competitorCode') as string,
			ellipsis: true,
			width: 200,
		},
		{
			key: "competitorName",
			dataIndex: "competitorName",
			title: this.$t('shared.table.competitorName') as string,
			sorter: true,
			ellipsis: true,
			width: 200,
			scopedSlots: {
				filterDropdown: "competitorNameFilter",
				filterIcon: "competitorNameFilterIcon",
			},
			filters: [{text: this.$t('shared.selectBox.notSelected') as string, value: "all"}],
		},
		{
			key: "competitorFormat",
			dataIndex: "competitorFormat",
			title: this.$t('shared.table.competitorFormat') as string,
			ellipsis: true,
			width: 200,
		},
		{
			key: "address",
			dataIndex: "address",
			title: this.$t('shared.table.competitorAddress') as string,
			ellipsis: true,
			width: 200,
			scopedSlots: {
				filterDropdown: "competitorAddressFilter",
				filterIcon: "competitorAddressFilterIcon",
			},
			filters: [{text: this.$t('shared.selectBox.notSelected') as string, value: "all"}],
		},
		{
			key: "competitorPriority",
			dataIndex: "competitorPriority",
			title: this.$t('shared.table.competitorPriority') as string,
			scopedSlots: {customRender: "competitorPriority"},
			sorter: true,
			width: 200,
		},
		{
			key: "storeActions",
			dataIndex: "storeActions",
			title: this.$t('shared.table.actions') as string,
			width: 150,
			scopedSlots: {customRender: "storeActions"},
		},
	];
	competitorsData: any[] = [];
	pagination = {
		current: 1,
		pageSize: 7,
		total: 40,
		position: "bottom",
	};

	// функционал части таблицы
	get checkedStoreIds(): string[] {
		return this.competitorsData.filter((item) => item.storeChecked).map((item) => item.id || null);
	}
	get checkedStoreCodes(): string[] {
		return this.competitorsData.filter((item) => item.storeChecked).map((item) => item.competitorCode);
	}

	get hasActiveStoreFormatFilter(): boolean {
		return this.theFilters.storeFormat.some((item) => item.isSelected);
	}

	get hasActiveStoreRegionFilter(): boolean {
		return this.theFilters.storeRegion.some((item) => item.isSelected);
	}

	get hasActiveStoreClusterFilter(): boolean {
		return this.theFilters.storeCluster.some((item) => item.isSelected) || this.competitorsFilters.isClusterEmpty;
	}

	get hasActiveCompetitorNameFilter(): boolean {
		return this.competitorsFilters.theCompetitorName.length > 0;
	}

	get hasActiveCompetitorAddressFilter(): boolean {
		return this.competitorsFilters.theAddress.length > 0;
	}

	badgeStyle() {
		const condition = !!this.competitorsFilters.theErrorAmount;
		return {
			backgroundColor: "white",
			size: "10px",
			color: condition ? "red" : "gray",
			borderColor: condition ? "red" : "gray",
		};
	}

	handleClusterEmptyPick(eve: any) {
		this.competitorsFilters.isClusterEmpty = eve.target.checked
	}

	resetStoreFormatFilter(confirm?: Function) {
		// Emit "all" to reset the format filter
		this.$emit('filteredFormat', ["all"]);
		// Use setTimeout to ensure parent component processes the event first
		setTimeout(() => {
			this.fetchTableData();
			if (confirm) confirm();
		}, 0);
	}

	resetStoreRegionFilter(confirm?: Function) {
		// Emit "all" to reset the region filter
		this.$emit('filteredRegion', ["all"]);
		// Use setTimeout to ensure parent component processes the event first
		setTimeout(() => {
			this.fetchTableData();
			if (confirm) confirm();
		}, 0);
	}

	resetStoreClusterFilter(confirm?: Function) {
		// Reset both cluster filter and empty checkbox
		this.competitorsFilters.isClusterEmpty = false;
		this.$emit('filteredCluster', ["all"]);
		// Use setTimeout to ensure parent component processes the event first
		setTimeout(() => {
			this.fetchTableData();
			if (confirm) confirm();
		}, 0);
	}

	applyStoreCommonFilter(confirm?: Function) {
		this.fetchTableData();
		if (confirm) confirm();
	}

	
	resetCompetitorNameFilter(confirm?: Function) {
		this.competitorsFilters.theCompetitorName = '';
		this.fetchTableData();
		if (confirm) confirm();
	}


	resetCompetitorAddressFilter(confirm?: Function) {
		this.competitorsFilters.theAddress = '';
		this.fetchTableData();
		if (confirm) confirm();
	}


	handleTableChange(pagination: any, filters: any, sorter: any) {
		this.pagination.current = pagination.current;
		this.pagination.pageSize = pagination.pageSize;
		this.competitorsFilters.theSortField = sorter.columnKey || "competitorName";
		this.competitorsFilters.theSortDirectorion = sorter.order === "ascend" ? "ASC" : "DESC";
		this.fetchTableData()
	}

	handlePriorityChange(event: Event, record: any) {
		const input = event.target as HTMLInputElement;

		record.competitorPriority = input.value;
		record.competitorPriorityModified = true;
	}

	handlelPriorityReset(event: Event, record: any) {
		record.competitorPriority = record.competitorPriorityInitial;
		record.competitorPriorityModified = false;
	}

	handleMarketCheck() {
		if (!this.theMarket) {
			this.showInfo(this.$t('priceMonitoring.competitorsDirectory.selectTradingCompany') as string);
			return false;
		} else {
			return true;
		}
	}

	handleDeleteModalOpen(recordIds: any) {
		this.competitorsBody.theDeleteModal = true;
		this.competitorsBody.theDeleteIds = recordIds;
	}

	handeDownloadTextFile(content: any, fileName = this.$t('priceMonitoring.competitorsDirectory.errorsDownloadFileName') as string) {
		const blob = new Blob([content], {type: "text/plain"});
		const link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.download = fileName;
		link.click();
		URL.revokeObjectURL(link.href);
	}

	// функционал реквестов

	async fetchTableData() {
		let filters = this.competitorsFilters;
		let storeFormat = this.theFilters.storeFormat.filter((item) => item.isSelected).map((item) => item.id || null);
		let storeRegion = this.theFilters.storeRegion.filter((item) => item.isSelected).map((item) => item.id || null);
		let storeCluster = this.theFilters.storeCluster.filter((item) => item.isSelected).map((item) => item.id || null);

		let obj = {
			tradingId: this.theMarket ? this.theMarket.id : null,
			storeFormatIds: storeFormat.length ? storeFormat : null,
			storeRegionIds: storeRegion.length ? storeRegion : null,
			storeClusterIds: filters.isClusterEmpty ? [...storeCluster, -1] : storeCluster.length ? storeCluster : null,
			competitorName: filters.theCompetitorName,
			address: filters.theAddress,
			page: this.pagination.current - 1,
			size: this.pagination.pageSize,
			sortField: filters.theSortField,
			sortDirection: filters.theSortDirectorion,
		};
		try {
			this.competitorsBody.isTableLoading = true;
			const response = await this.$http.post(`/api/competitors-directory`, obj);

			const competitors = response.data.content.map((item: any) => ({
				...item,
				competitorPriorityInitial: item.competitorPriority,
				storeChecked: false,
				storeActions: ["Delete"],
			}));

			this.competitorsData = competitors;
			this.pagination.total = response.data.totalElements;
			this.pagination.pageSize = response.data.size;
		} catch (error) {
			this.showError(this.$t('priceMonitoring.competitorsDirectory.errorLoadData') as string);
			console.error("Error uploading file:", error);
		} finally {
			this.fetchErrorsAmount();
			setTimeout(() => {
				this.competitorsBody.isTableLoading = false;
			}, 100);
		}
	}

	async fetchUpdatePriority(id: any, priority: any) {
		try {
			this.competitorsBody.isTableLoading = true;
			const response = await this.$http.put(`/api/competitors-directory`, {items: [{id: id, competitorPriority: priority}]});
		} catch (error) {
			console.error("Error uploading file:", error);
			this.showError(this.$t('priceMonitoring.competitorsDirectory.errorUpdatePriority') as string);
		} finally {
			setTimeout(() => {
				this.competitorsBody.isTableLoading = false;
				this.fetchTableData();
			}, 300);
		}
	}

	async fetchDeleteRecord() {
		try {
			this.competitorsBody.isTableLoading = true;
			const response = await this.$http.delete(`/api/competitors-directory?tradingId=${this.theMarket.id}`, {
				data: {
					itemsToDelete: this.competitorsBody.theDeleteIds,
				},
			});
		} catch (error) {
			console.error("Error uploading file:", error);
			this.showError(this.$t('priceMonitoring.competitorsDirectory.errorDeleteRecord') as string);
		} finally {
			setTimeout(() => {
				this.competitorsBody.theDeleteIds = [];
				this.competitorsBody.isTableLoading = false;
				this.fetchTableData();
			}, 300);
		}
	}

	async fetchFileUpload(action: any) {
		if (!this.competitorsFilters.theFile) return;
		const formData = new FormData();
		formData.append("file", this.competitorsFilters.theFile);

		try {
			this.competitorsBody.isTableLoading = true;
			const response = await this.$http.post(`/api/competitors-directory/upload?tradingId=${this.theMarket.id}&uploadOption=${action}`, formData);
			if (response.status == 200) this.showInfo(this.$t('priceMonitoring.competitorsDirectory.fileUploadSuccess') as string);
		} catch (error) {
			this.showError(this.$t('priceMonitoring.competitorsDirectory.errorUploadFile') as string);
			console.error("Error uploading file:", error);
		} finally {
			this.competitorsBody.isTableLoading = false;
			this.competitorsFilters.theFile = null;
			this.fetchTableData();
		}
	}

	async fetchFileExport() {
		let body = {
			tradingId: this.theMarket ? this.theMarket.id : null,
			storeFormatIds: null,
			storeRegionIds: null,
			storeClusterIds: null,
			competitorName: null,
			address: null,
			page: 0,
			size: 20,
			sortField: "competitorName",
			sortDirectorion: "ASC",
		};

		try {
			this.competitorsBody.isTableLoading = true;

			const response = await this.$http.post(`/api/competitors-directory/export`, body, {responseType: "blob"});
			const dateString = moment().format("YYYYMMDD_HHmmss");
			const fileName = `${this.$t('priceMonitoring.tabs.competitorsDirectory') as string}_${dateString}.xlsx`;

			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileName);

			document.body.appendChild(link);
			link.click();

			window.URL.revokeObjectURL(url);
			document.body.removeChild(link);
		} catch (error) {
			console.error("Error exporting file:", error);
			this.showError(this.$t('priceMonitoring.competitorsDirectory.errorExportFile') as string);
		} finally {
			setTimeout(() => {
				this.competitorsBody.isTableLoading = false;
			}, 300);
		}
	}

	async fetchFullUpdate() {
		try {
			this.competitorsBody.isTableLoading = true;
			this.competitorsBody.isTableFullUpdating = true;
			const response = await this.$http.post(`/api/competitors-directory/update-competitors-original?tradingId=${this.theMarket.id}`);
			if (response.status == 200) this.showInfo(this.$t('priceMonitoring.competitorsDirectory.competitorsUpdatedSuccess') as string);
		} catch (error) {
			this.showInfo(this.$t('priceMonitoring.competitorsDirectory.errorUpdateCompetitors') as string);
			console.error("Error exporting file:", error);
		} finally {
			setTimeout(() => {
				this.competitorsBody.isTableLoading = false;
				this.competitorsBody.isTableFullUpdating = false;
			}, 300);
		}
	}

	async fetchErrorsAmount() {
		try {
			this.competitorsBody.isTableLoading = true;
			const response = await this.$http.get(`/api/error/list/files/last/amount?tradingId=${this.theMarket.id}&fileType=COMPETITORS_DIRECTORY`);
			this.competitorsFilters.theErrorAmount = response.data;
		} catch (error) {
			console.error("Error exporting file:", error);
		} finally {
			setTimeout(() => {
				this.competitorsBody.isTableLoading = false;
			}, 300);
		}
	}

	async handleErrorsDownload() {
		try {
			this.competitorsBody.isTableLoading = true;
			const response = await this.$http.get(`/api/error/list/files/last?tradingId=${this.theMarket.id}&fileType=COMPETITORS_DIRECTORY`);

			if (!response.data.length) {
				this.showInfo(this.$t('shared.messages.noErrors') as string);
				return;
			}

			this.handeDownloadTextFile(response.data);
		} catch (error) {
			this.showError(this.$t('priceMonitoring.competitorsDirectory.errorLoadErrors') as string);
			console.error("Error exporting file:", error);
		} finally {
			setTimeout(() => {
				this.competitorsBody.isTableLoading = false;
			}, 300);
		}
	}

	mounted() {
		this.fetchErrorsAmount();
	}
}
